import React, {Component} from "react";
import {connect} from "react-redux";
import {List, fromJS, Map} from "immutable";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import FilterPanel from "../../components/panels/FilterPanel";
import ClientDispatchesList from "./views/ClientDispatchesList";
import ClientDispatchDetails from "./views/ClientDispatchDetails";
import ShippedSerialsReport from "./views/ShippedSerialsReport";
import {ClientDispatchStatusPanel, ClientDispatchInfoPanel, ClientDispatchActionsPanel} from "./panels/ClientDispatchPanels";
import {requestCreateClientDispatch} from "../../actions/ClientDispatchApiActions";
import {getAllWarehouses, addAllWarehousesOption} from "../../lib/Warehouses";

const statusFilterKey = "status";
const originFilterKey = "origin_warehouse_id";
const statusFilterOptions = fromJS([
  {id: "", label: "All Dispatches"},
  {id: "draft", label: "Draft"},
  {id: "shipped", label: "Shipped"},
  {id: "cancelled", label: "Cancelled"},
]);

// Pages: "client-dispatches" (list), "client-dispatch" (one, by :id) and
// "client-shipped-serials" (the serial numbers shipped to clients).
class ClientDispatchesPage extends Component {

  render() {
    const page = this.props.route.page;
    const titles = {
      "client-dispatch": `Client Dispatches / ${this.props.params.id}`,
      "client-shipped-serials": "Client Dispatches / Serial Numbers Shipped",
    };

    return (
      <div className="ClientDispatchesPage SecurePage">
        <AppSidebar />
        <PageHeader title={titles[page] || "Client Dispatches"} backButton={page !== "client-dispatches"}
          onBack={() => this.props.router.push("/client-dispatches")} />
        <div className="PageContainer">
          {this.renderView(page)}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {page === "client-dispatches" && this.renderFilters()}
          {page === "client-dispatch" && [
            <ClientDispatchStatusPanel key="status" clientDispatchId={this.props.params.id} />,
            <ClientDispatchInfoPanel key="info" clientDispatchId={this.props.params.id} />,
            <ClientDispatchActionsPanel key="actions" clientDispatchId={this.props.params.id} />,
          ]}
          {page === "client-dispatches" &&
            <PanelGroupController title="Actions">
              <ActionButton label="Create Dispatch" onClick={() => this.props.requestCreateClientDispatch()} />
              <ActionButton label="Serial Numbers Shipped" primary={false}
                onClick={() => this.props.router.push("/client-shipped-serials")} />
            </PanelGroupController>}
        </div>
      </div>
    );
  }

  renderView(page) {
    const query = Map(this.props.router.location.query);
    switch(page) {
      case "client-dispatch":
        return <ClientDispatchDetails clientDispatchId={this.props.params.id} />
      case "client-shipped-serials":
        return <ShippedSerialsReport />
      default:
        return (
          <ClientDispatchesList
            onSelectionChange={(id) => this.props.router.push(`/client-dispatches/${id}`)}
            statusFilter={query.get(statusFilterKey, "")}
            originFilter={query.get(originFilterKey, "")}
            />
        )
    }
  }

  renderFilters() {
    const query = Map(this.props.router.location.query);
    return List([
      <FilterPanel key="status" title="Status Filter" expanded={true} options={statusFilterOptions}
        onClick={(item) => this.setQuery(statusFilterKey, item.get("id"))} filter={query.get(statusFilterKey, "")} />,
      <FilterPanel key="origin" title="From Warehouse" expanded={true} options={addAllWarehousesOption(getAllWarehouses())}
        onClick={(item) => this.setQuery(originFilterKey, item.get("id"))} filter={query.get(originFilterKey, "")} />,
    ]);
  }

  setQuery(key, value) {
    const query = Map(this.props.router.location.query);
    this.props.router.push({
      pathname: "/client-dispatches",
      query: (value === "" ? query.delete(key) : query.set(key, value)).toJS()
    });
  }
}

export default connect(null, {requestCreateClientDispatch})(ClientDispatchesPage);
